import React from "react"

import AssistantPanelContent from "~components/outfitter-assistant/assistant-panel-content"
import { OUTFITTER_ASSISTANT_EXCLUDE_ATTR } from "~components/outfitter-assistant/outfitter-assistant-constants"
import { ASSISTANT_BOTTOM_SHEET_VARIANTS } from "~components/outfitter-assistant/assistant-presentation-motion"
import BottomSheet from "~components/shared/bottom-sheet"
import COPY from "~config/copy-constants"
import { TEST_IDS } from "~config/constants"

const EXCLUDE_PROPS = { [OUTFITTER_ASSISTANT_EXCLUDE_ATTR]: "" } as const
const BOTTOM_SHEET_HEIGHT = "88dvh"

interface Props {
    readonly onClose: () => void
}

export default function AssistantMobileBottomSheet({ onClose }: Props) {
    return (
        <BottomSheet
            dragHandleAriaLabel={COPY.OUTFITTER_ASSISTANT_DRAG_HANDLE_ARIA}
            height={BOTTOM_SHEET_HEIGHT}
            onClose={onClose}
            testId={TEST_IDS.OUTFITTER_ASSISTANT_PANEL}
            variants={ASSISTANT_BOTTOM_SHEET_VARIANTS}
            {...EXCLUDE_PROPS}
        >
            <AssistantPanelContent />
        </BottomSheet>
    )
}
